import React from 'react';
import { DialogProviderContextModel } from 'models/DialogProviderContext'
import { uuidv4 } from 'utils'

export class DialogHandle {
    dialogProvider: DialogProviderContextModel;
    render: (handle: DialogHandle) => React.ReactNode;
    id?: string;

    constructor(dialogProvider: DialogProviderContextModel, render: (handle: DialogHandle) => React.ReactNode) {
        this.dialogProvider = dialogProvider;
        this.render = render;
    }

    open = () => {
        if (this.isOpen()) {
            return; // dialog is already open
        }
        this.id = uuidv4();
        this.dialogProvider.pushDialog({ id: this.id, component: this.render(this) });
    }

    close = () => {
        if (!this.id) {
            return; // dialog not open
        }
        this.dialogProvider.forceDismissDialog(this.id);
        this.id = undefined;
    }

    isOpen = () => {
        return !!this.id;
    }

    update = (render: (handle: DialogHandle) => React.ReactNode) => {
        this.render = render;
        if (this.isOpen() && this.id) {
            // cause re-render of opened dialog
            this.dialogProvider.updateDialog({ id: this.id, component: render(this) });
        }
    }
}